module.exports = __webpack_public_path__ + "static/media/ic_mind_health.f4e891c8.svg";